import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "regles-menus"
}
const _hoisted_4 = { class: "regles-menus__entete" }
const _hoisted_5 = { class: "regles-menus__contenu" }
const _hoisted_6 = { class: "regles-menus__groupe-titre" }
const _hoisted_7 = { class: "regles-menus__item-titre" }
const _hoisted_8 = { class: "regles-menus__item-condition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isActif)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.panneauOuvert)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "regles-menus__bouton-ouvrir",
              title: _ctx.$t('regles_gestion.menus.ouvrir'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ouvrir && _ctx.ouvrir(...args)))
            }, " RÈGLES DES MENUS ", 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Règles d'affichage des menus", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "regles-menus__fermer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fermer && _ctx.fermer(...args)))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.REGLES_MENUS, (groupe) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: groupe.titre,
                    class: "regles-menus__groupe"
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(groupe.titre), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupe.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.titre,
                        class: "regles-menus__item"
                      }, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.titre), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.condition), 1)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}